module.exports = __webpack_public_path__ + "img/Katameya.851e87e6.png";